/**
 * Prezzo unico Kipo: tutto incluso, per utente attivo. IVA esclusa.
 * I piani Kairos (free/start/pro/business) sono ritirati.
 */
export const PLAN_CODE = "kipo" as const;
export const PRICE_PER_USER_MONTH_CENTS = 1400;
/** Annuale anticipato: due mesi gratis. */
export const PRICE_PER_USER_YEAR_CENTS = PRICE_PER_USER_MONTH_CENTS * 10;
export const TRIAL_DAYS = 7;
export const VAT_RATE = 22;

export const ENTITLEMENT_STATUSES = ["trialing", "active", "past_due", "canceled", "expired"] as const;
export type EntitlementStatus = (typeof ENTITLEMENT_STATUSES)[number];
export type BillingInterval = "month" | "year";

/** Stati in cui il tenant può usare la suite. */
export function isUsable(status: EntitlementStatus): boolean {
  return status === "trialing" || status === "active" || status === "past_due";
}

export function quoteSubscription(seats: number, interval: BillingInterval) {
  const unit = interval === "year" ? PRICE_PER_USER_YEAR_CENTS : PRICE_PER_USER_MONTH_CENTS;
  const net = unit * Math.max(1, seats);
  const vat = Math.round((net * VAT_RATE) / 100);
  return { unitCents: unit, netCents: net, vatCents: vat, totalCents: net + vat };
}
